import { Box, Flex, Image, Text, Badge } from '@chakra-ui/react';
import React from 'react';
import dayjs from 'dayjs';

export default function StudentInfo({ estudiante }) {
  const user = estudiante?.user;

  return (
    <Box
      bg="white"
      borderRadius="xl"
      border="1px solid"
      borderColor="gray.200"
      p={5}
    >
      {/* Avatar */}
      <Flex justify="center" mb={4}>
        {user?.image ? (
          <Image
            src={user.image.url}
            w="120px"
            h="120px"
            objectFit="cover"
            borderRadius="full"
          />
        ) : (
          <Flex
            bg="#574feb"
            w="120px"
            h="120px"
            borderRadius="full"
            align="center"
            justify="center"
            fontSize="40px"
            fontWeight="600"
            color="white"
          >
            {user?.first_name?.[0]?.toUpperCase() || ''}
            {user?.last_name?.[0]?.toUpperCase() || ''}
          </Flex>
        )}
      </Flex>

      {/* Name */}
      <Text fontWeight="bold" fontSize="lg" textAlign="center" mb={1}>
        {user?.first_name} {user?.last_name}
      </Text>

      <Flex justify="center" mb={4}>
        <Badge
          colorScheme={estudiante.active !== false ? 'green' : 'red'}
          borderRadius="full"
          px={2}
        >
          {estudiante.active !== false ? 'Activo' : 'Inactivo'}
        </Badge>
      </Flex>

      {/* Info fields */}
      <Box fontSize="sm" color="gray.700">
        <InfoRow label="Codigo" value={estudiante.id} />
        <InfoRow label="Email" value={user?.email} />
        <InfoRow label="Celular" value={user?.cellphone} />
        {user?.country && (
          <InfoRow label="Pais" value={`${user.country.name} (+${user.country.phone_code})`} />
        )}
        <InfoRow
          label="Fecha registro"
          value={user?.createdAt ? dayjs(user.createdAt).format('DD/MM/YYYY') : '-'}
        />
        {(estudiante.birthdate || user?.birthdate) && (
          <>
            <InfoRow
              label="Fecha nacimiento"
              value={dayjs(estudiante.birthdate || user.birthdate).format('DD/MM/YYYY')}
            />
            <InfoRow
              label="Edad"
              value={`${dayjs().diff(dayjs(estudiante.birthdate || user.birthdate), 'year')} anos`}
            />
          </>
        )}
      </Box>
    </Box>
  );
}

function InfoRow({ label, value }) {
  if (!value) return null;
  return (
    <Box py={1} borderBottom="1px solid" borderColor="gray.100">
      <Text fontSize="xs" color="gray.500" fontWeight="500">
        {label}
      </Text>
      <Text fontSize="sm" wordBreak="break-all">
        {value}
      </Text>
    </Box>
  );
}
